import { render, staticRenderFns } from "./TimeSpanExpressionBehaviorEditor.vue?vue&type=template&id=65c7af4b&scoped=true&"
import script from "./TimeSpanExpressionBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./TimeSpanExpressionBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TimeSpanExpressionBehaviorEditor.vue?vue&type=style&index=0&id=65c7af4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c7af4b",
  null
  
)

export default component.exports